import React, {useRef, useState} from 'react';
import Paper from '@material-ui/core/Paper';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import SendIcon from '@material-ui/icons/Send';
import Button from '@material-ui/core/Button';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';
import SpeakerNotesIcon from '@material-ui/icons/SpeakerNotes';
import CannedResponses from './CannedResponses';

const useStyles = makeStyles((theme) => ({
  root: {
    margin: 10
  },
  container: {
    paddingTop: 4,
    paddingBottom: 4,
    position: 'absolute',
    bottom: 0,
    width: '100%'
  },
  input: {
    //    width: '70%',
    [`& fieldset`]: {
      borderRadius: 20,
    },
  },
  button: {
    marginLeft: 10,
  },
}));


export default function footer(props) {
  const classes = useStyles();
  const input = useRef(null);
  const [cannedOpen, setCannedOpen] = useState(false);

  const handleClickSend = () => {
    console.log("Send clicked" );
    let msg = input.current.value;
    input.current.value = '';
    props.sendMessage(msg);
  }

  const openCannedResponses = () => {
    console.log("Displaying canned responses list");
    setCannedOpen( ! cannedOpen );
  }

  const handleSubmit = (ev) => {
    ev.preventDefault();
    handleClickSend();
    return false;
  }

  const handleKeyup = (ev) => {
    if(props.sendTyping) {
      props.sendTyping();
    }
  }

  const sendCannedResponse = (msg) => {
    input.current.value = msg;
    setCannedOpen(false);
    handleClickSend();
  }

  return (
    <Paper classes={{root: classes.container}} square={true} elevation={4}>
      { (props.cannedResponses && cannedOpen) ? <CannedResponses items={props.cannedResponses} onClick={sendCannedResponse} /> : '' }
      <form className={classes.root} noValidate autoComplete="off" onSubmit={handleSubmit}>
        <TextField classes={{ root: classes.input }} id="message" label={props.label || "Chat message"} variant="outlined" size="small" fullWidth={true}
          inputProps={{
            ref: input,
            onKeyUp: handleKeyup,
          }}
          InputProps={{
          endAdornment:
          <InputAdornment position="end">
            { props.cannedResponses ?
            <IconButton
              aria-label="canned response"
              color={ cannedOpen ? 'primary' : 'default' }
              onClick={openCannedResponses}
            >
              <SpeakerNotesIcon />
            </IconButton>
            : ''
            }
            <IconButton
              aria-label="send message"
              onClick={handleClickSend}
            >
              <SendIcon />
            </IconButton>
          </InputAdornment>
          }}
        />
      </form>
    </Paper>
    );
}
